import React, { FC, memo } from "react";
import { useMedia } from "react-use";

import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { ICustomField } from "@/data/custom-fields";
import { Flex } from "@/eworkitComponents";

import { CustomFieldValue } from "./CustomFieldValue";

export interface ICustomFieldProps {
  customField: ICustomField;
}

export const CustomField: FC<ICustomFieldProps> = memo(({ customField }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Flex direction={isSmallScreen ? "column" : "row"} innerPadding={isSmallScreen ? undefined : "sm"}>
      <Flex width={{ xs: 12, sm: 3 }}>
        <Text color="grey2">{customField.name}</Text>
      </Flex>

      <Flex width={{ xs: 12, sm: 9 }}>
        <CustomFieldValue type={customField.type} value={customField.value} />
      </Flex>
    </Flex>
  );
});
